"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Page = function () {
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "page404" }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h2", __assign({ style: { textAlign: 'center' } }, { children: "404" })), (0, jsx_runtime_1.jsx)("p", __assign({ style: { textAlign: 'center' } }, { children: "OPPS! PAGE NOT FOUND" }))] }) })));
};
exports.default = Page;
